module.exports = __webpack_public_path__ + "static/media/ls-2.730c14a0.jpg";